import React, { useEffect, useState } from "react";
import "./Compare_page.css";
import CompareTable from "./CompareTable";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";

function ComparePage() {
  const [catagoryList, setCatagoryList] = useState([]);
  const [compareItemsData, setCompareItemsData] = useState([]);
  const [currentCatagory, setCurrentCatagory] = useState(null);

  useEffect(() => {
    const comparedItems = JSON.parse(localStorage.getItem("compareItems"));
    if (comparedItems) {
      const uniqueCategories = [...new Set(comparedItems.map(product => product.catagory))];
      setCatagoryList(uniqueCategories);
      setCurrentCatagory(uniqueCategories[0]);
      const filteredProducts = comparedItems.filter(product => product.catagory === uniqueCategories[0]);
      setCompareItemsData(filteredProducts);
      //console.log("Filtered products:", filteredProducts);
      //console.log("Unique categories:", uniqueCategories);
      //console.log("Current catagory:", uniqueCategories[0]);
    }
  }, []);

  useEffect(() => {
    if (currentCatagory) {
      const filteredProducts = JSON.parse(localStorage.getItem("compareItems")).filter(product => product.catagory === currentCatagory);
      setCompareItemsData(filteredProducts);
    }
  }, [currentCatagory]);

  const handleRemoveProduct = (productToRemove) => {
    const comparedItems = JSON.parse(localStorage.getItem("compareItems")) || [];
    const updatedItems = comparedItems.filter(item => item.model !== productToRemove.model);
    localStorage.setItem("compareItems", JSON.stringify(updatedItems));

    const filteredProducts = updatedItems.filter(product => product.catagory === currentCatagory);
    setCompareItemsData(filteredProducts);

    const uniqueCategories = [...new Set(updatedItems.map(product => product.catagory))];
    setCatagoryList(uniqueCategories);

    if (filteredProducts.length === 0 && uniqueCategories.length > 0) {
      setCurrentCatagory(uniqueCategories[0]);
    }
  };
  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>
      <div className="compare-page-container">
        <h1>Compare</h1>
        <div className="compare-page-catagory-list-container">
          {
            catagoryList.map((catagory, index) => (
              <p key={index} onClick={() => setCurrentCatagory(catagory)} className={`compare-page-catagory-list ${currentCatagory === catagory ? 'active' : ''}`}>{catagory} | </p>
            ))
          }
        </div>
        <div>
          {
            compareItemsData.length > 0 ? (
              // <CompareTable
              //   products={compareItemsData}
              //   onRemoveProduct={handleRemoveProduct}
              // />
              <CompareTable compareItems={compareItemsData} onDelete={handleRemoveProduct} />
            ) : (
              <p>No products to compare</p>
            )}
        </div>
      </div>

      <About_p />
      <Footer />
      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }

      <StickyComponent />
    </>
  );
}

export default ComparePage;